import { Button } from '@blueprintjs/core';
import classes from './CollateralCardToolbar.module.css';
import { useCollateralFormContext } from '../../forms/collateral/context';
import {
  lock_hooks,
  useApplicationStatusUtils,
  useLoanApplication,
} from '@axo/shared/data-access/hooks';
import { ConditionalTooltip } from '../ConditionalTooltip/ConditionalTooltip';
import { useCollateralFormStore } from '../../forms/collateral/store';

let id = 0;

function generateUniqueLocalId() {
  return String(id++);
}

interface CollateralCardToolbarProps {
  applicationID: string;
}

export const CollateralCardToolbar: React.FC<CollateralCardToolbarProps> = ({
  applicationID,
}) => {
  const {
    isEditing,
    actions: { setIsEditing },
  } = useCollateralFormStore(applicationID);
  const { formState, submit } = useCollateralFormContext(applicationID);

  const { data: applicationData } = useLoanApplication(applicationID);
  const hasLock = lock_hooks.useCurrentUserHasLock(
    applicationID,
    applicationData?.MarketCountry,
  ).data;

  const { isFinalApplicationStatus } = useApplicationStatusUtils();

  return (
    <div className={classes.rootContainer}>
      <ConditionalTooltip
        conditions={[
          {
            isTooltipVisible: isEditing.size === 0 || !formState.isDirty,
            isChildDisabled: true,
            tooltipContent: 'Nothing to save',
          },
          {
            isTooltipVisible: !hasLock,
            isChildDisabled: true,
            tooltipContent: "You don't own the lock for this application",
          },
        ]}
        render={(disabled) => (
          <Button
            icon="floppy-disk"
            loading={formState.isSubmitting}
            onClick={() => submit()}
            disabled={disabled}
            intent="primary"
          >
            Save all
          </Button>
        )}
      />

      <ConditionalTooltip
        conditions={[
          {
            isTooltipVisible: Boolean(
              applicationData?.Status &&
                isFinalApplicationStatus(applicationData.Status),
            ),
            tooltipContent:
              "This application is in a final status and can't be edited",
            isChildDisabled: true,
          },
          {
            isTooltipVisible: !hasLock,
            isChildDisabled: true,
            tooltipContent: "You don't own the lock for this application",
          },
        ]}
        render={(disabled) => (
          <Button
            loading={formState.isSubmitting}
            onClick={() => {
              const id = generateUniqueLocalId();
              setIsEditing({ id, isEditing: true, localOnly: true });
            }}
            icon="plus"
            disabled={disabled}
          >
            Add property
          </Button>
        )}
      />
    </div>
  );
};
